import { RecordType } from "../types"

export const omitUndefined = <T extends RecordType>(obj: T): T => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined),
  ) as T
}
